import React from 'react'
import Masthead from './Masthead'
import ContactForm from './ContactForm'
import ContactInfo from './ContactInfo'
import SocialLinks from './SocialLinks'
import PartnersTutors from './PartnersTutors'
import FAQBlock from './FAQBlock'

function MainContent() {
   return (
      <div className=''>
         <Masthead />
         <ContactForm />
         <ContactInfo />
         <SocialLinks />
         <PartnersTutors />
         <FAQBlock />
         {/* <ContactContent />
         <FrequentlyAskedQuestions /> */}
      </div>
   )
}

export default MainContent